import type { TListSortField, TListSortOrder, TSortListDropdownValue } from '../../types';

export function dropdownValueToSorting(
  value: TSortListDropdownValue,
): { sort: TListSortField; order: TListSortOrder } {
  switch (value) {
    case 'create_time_asc':
      return { sort: 'create_time', order: 'asc' };
    case 'create_time_desc':
      return { sort: 'create_time', order: 'desc' };
    case 'user_data_asc':
      return { sort: 'user_data', order: 'asc' };
    case 'user_data_desc':
      return { sort: 'user_data', order: 'desc' };
    default:
      return { sort: 'create_time', order: 'desc' };
  }
}

export function sortingToDropdownValue(
  sort?: TListSortField,
  order?: TListSortOrder,
): TSortListDropdownValue {
  if (sort === 'user_data' && order === 'asc') return 'user_data_asc';
  if (sort === 'user_data' && order === 'desc') return 'user_data_desc';
  if (sort === 'create_time' && order === 'asc') return 'create_time_asc';

  return 'create_time_desc';
}
